<template>
  <div id="PeopleProfile">
    <b-container fluid>
      <b-row>
        <b-col cols="2" class="person_info">
          <b-img
            v-if="!imageLoadError"
            :lazy-src="person.thumbURL"
            class="profile_image"
            :src="person.thumbURL"
            @error="imageLoadError = true"
          ></b-img>
          <div v-else class="profile_image profile_image_placeholder"></div>
          <div>
            <p class="person_header">
              {{ person.name }}
            </p>
            <p v-if="person.dateOfPassing.date.length == 0" class="person_time">
              Born: {{ person.dateOfBirth.date }}
            </p>
            <p v-else class="person_time">
              Born: {{ person.dateOfBirth.date }}
              <small v-if="person.dateOfBirth.era == false">BC</small><br />
              Passing: {{ person.dateOfPassing.date }}
              <small v-if="person.dateOfPassing.era == false">BC</small>
            </p>
            <p
              v-if="
                person.dateOfPassing.date.length > 0 &&
                  person.dateOfPassing.era &&
                  person.dateOfBirth.date.length <= 4
              "
              class="person_subheader"
            >
              {{ person.dateOfPassing.date - person.dateOfBirth.date }} yrs
            </p>
            <p
              v-else-if="
                person.dateOfPassing.date.length > 0 &&
                  person.dateOfPassing.era == false &&
                  person.dateOfBirth.date.length <= 4
              "
              class="person_subheader"
            >
              {{ person.dateOfBirth.date - person.dateOfPassing.date }} yrs
            </p>
            <p v-else></p>
          </div>
        </b-col>
        <b-col lg="6" md="12" sm="12" class="pb-2">
          <div class="text person_description" v-html="content"></div>
          <b-button class="person_link" size="sm" @click="goTo()"
            >Learn More</b-button
          >
        </b-col>
        <b-col>
          <b-row>
            <b-col
              v-for="(resource, i) in resources"
              :key="i"
              class="pb-1"
              lg="12"
              md="6"
              sm="12"
            >
              <div
                v-if="i < 2 && embedStatusMap[resource.url] === 'playable'"
                class="loading"
              >
                <iframe
                  class="person_iframe"
                  :src="'https://www.youtube.com/embed/' + resource.url"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import storeTopic from "@/store/topic.js";
import * as Quill from "quill";
import { pushRoute } from "@/router/navigation";
import { trackEvent } from "@/services/analyticsService";
import { checkYouTubeEmbed } from "@/services/youtubeEmbedCheck";
export default {
  name: "PeopleProfile",
  props: {
    person: Object
  },
  data() {
    return {
      embedStatusMap: {},
      imageLoadError: false
    };
  },
  computed: {
    content() {
      var inputDelta = this.person.mainMD;
      var tempCont = document.createElement("div");
      if (typeof inputDelta === "string" || inputDelta instanceof String) {
        return (tempCont.innerHTML = inputDelta);
      } else {
        var quill = new Quill(tempCont);
        quill.setContents(inputDelta);
        return tempCont.getElementsByClassName("ql-editor")[0].innerHTML;
      }
    },
    resources() {
      var r = storeTopic.state.peopleResources.filter(resource => {
        return (
          resource.parentID === this.person.id &&
          resource.resourceType === "video"
        );
      });
      return r;
    }
  },
  watch: {
    resources: {
      immediate: true,
      handler() {
        this.runEmbedChecks();
      }
    }
  },
  methods: {
    async runEmbedChecks() {
      // Only check first two resources since only those are rendered
      const items = (this.resources || []).slice(0, 2);
      for (const res of items) {
        const idOrUrl = res.url;
        try {
          const status = await checkYouTubeEmbed(idOrUrl);
          this.$set(this.embedStatusMap, res.url, status);
        } catch (e) {
          this.$set(this.embedStatusMap, res.url, "unknown_error");
        }
      }
    },
    goTo() {
      storeTopic.dispatch("setPersonContent", this.person);
      pushRoute("Person", {
        period: this.$route.params.period,
        periodName: this.$route.params.periodName,
        topic: this.$route.params.topic,
        topicName: this.$route.params.topicName,
        category: "People",
        person: this.person.id
      });
      trackEvent("person_learn_more_clicked", {
        person_name: this.person.name || null,
        person_id: this.person.id || null
      });
    }
  }
};
</script>

<style lang="sass" scoped src="@/assets/css/topicContent.sass"></style>
<style lang="sass" scoped src="@/assets/css/loading.sass"></style>
